import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';

export default function AdvisoryBoardPage() {
  const [board, setBoard] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBoard();
  }, []);

  const fetchBoard = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/advisory-board');
      setBoard(response.data);
    } catch (error) {
      console.error('Error fetching advisory board:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-20 p-6 max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Advisory Board</h1>
          <p className="text-gray-600">I membri del nostro consiglio consultivo</p>
        </div>

        {loading ? (
          <div className="py-8">
            <p className="text-center text-gray-500">Caricamento...</p>
          </div>
        ) : board.length === 0 ? (
          <div className="py-8">
            <p className="text-center text-gray-600">Advisory Board in definizione – aggiornamenti a breve.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {board.map((member) => (
              <div key={member.id} className="border border-gray-200 rounded-lg p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {member.first_name} {member.last_name}
                </h3>
                {member.job_title && (
                  <p className="text-gray-600 mb-4">{member.job_title}</p>
                )}
                <div className="space-y-2 text-sm">
                  {member.company_name && (
                    <p><strong>Azienda:</strong> {member.company_name}</p>
                  )}
                  {member.email && (
                    <p><strong>Email:</strong> {member.email}</p>
                  )}
                  {member.linkedin_url && (
                    <a 
                      href={member.linkedin_url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline block"
                    >
                      🔗 LinkedIn
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
